import PhonelinkSetupIcon from "@mui/icons-material/PhonelinkSetup";
import {
	Box,
	Button,
	Dialog,
	FormControl,
	Grid,
	IconButton,
	List,
	ListItem,
	MenuItem,
	Select,
	Skeleton,
	Tooltip,
	Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import ControlledCheckbox from "../../components/controlled/ControlledCheckbox";
import ControlledSelect from "../../components/controlled/ControlledSelect";
import {
	useGetCurrentUserMailingGroupsQuery,
	useGetGroupRecipientsQuery,
} from "../recipients/recipientsApiSlice";

export const CargoFormSms = ({ control }) => {
	const [openDialog, setOpenDialog] = useState(false);

	return (
		<>
			<Box
				sx={{
					fontSize: "12px",
					display: "flex",
					alignItems: "center",
					gap: "10px",
				}}
			>
				<span>Wyślesz SMS-ów: 0</span>
				<Tooltip
					slotProps={{
						tooltip: { sx: { fontSize: "11px" } },
					}}
					sx={{ fontSize: "14px" }}
					title="Otwórz żeby skonfigurować listę odbiorców"
				>
					<IconButton
						sx={{ p: "2px" }}
						type="button"
						onClick={() => setOpenDialog(true)}
					>
						<PhonelinkSetupIcon />
					</IconButton>
				</Tooltip>
			</Box>
			<SmsDialog
				onClose={() => setOpenDialog(false)}
				open={openDialog}
				control={control}
			/>
		</>
	);
};

const SmsDialog = ({ onClose, open, control }) => {
	const [selectedGroup, setSelectedGroup] = useState(null);
	const [selectedContacts, setSelectedContacts] = useState([]);

	const {
		data: mailingGroups,
		error: mailingGroupsError,
		isLoading: isLoadingGroups,
	} = useGetCurrentUserMailingGroupsQuery();

	const {
		data: recipients,
		isLoading,
		isFetching,
	} = useGetGroupRecipientsQuery(
		{ groupId: selectedGroup },
		{ skip: !selectedGroup }
	);

	const filteredRecipients = useMemo(() => {
		if (!recipients) return [];

		return recipients.filter((r) => r.phone !== null);
	}, [recipients]);

	const mailingGroupOptions = useMemo(() => {
		if (!mailingGroups?.groups) {
			return [];
		}

		return Object.entries(mailingGroups?.groups).map(([key, name]) => ({
			value: key,
			label: name,
		}));
	}, [mailingGroups?.groups]);

	const handleSelectAllContacts = () => {
		const newContacts = filteredRecipients.filter(
			(fr) => !selectedContacts.some((sc) => sc.phone === fr.phone)
		);
		setSelectedContacts((prev) => [...prev, ...newContacts]);
	};

	console.log("selectedContacts", selectedContacts);

	return (
		<Dialog fullWidth maxWidth="md" onClose={onClose} open={open}>
			<Grid container spacing={0}>
				<Grid size={7.5}>
					<Grid container rowSpacing={1}>
						<Grid size={6}>
							<Box sx={{ background: "#caeefb", p: "5px 10px" }}>
								Dostępne SMS-y: <b>5400</b>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ background: "#f2cfee", p: "5px 10px" }}>
								Liczba SMS-ów dla tej wysyłki: <b>4</b>
							</Box>
						</Grid>
						<Grid size={12}>
							<Box sx={{ p: "0 16px" }}>
								<ControlledCheckbox
									control={control}
									margin="normal"
									name="smsToGroups"
									label={
										<span>
											Wyślij SMS do przewoźników z grupy mailingowej{" "}
											<em>(przewoźnik ma opcję kwotowania)</em>
											{/* <Link
												style={{
													marginLeft: "20px",
													color: "#0070C0",
												}}
												to="/recipients"
											>
												Zarządzaj grupami
											</Link> */}
										</span>
									}
								/>
								<Grid container spacing={1}>
									<Grid size={4}>
										<Box sx={{ alignItems: "center", display: "flex" }}>
											{isLoadingGroups ? (
												<Skeleton
													variant="rectangular"
													width={155.77}
													height={36.72}
												/>
											) : (
												<ControlledSelect
													control={control}
													allowRefresh={true}
													// resetField={resetField}
													// onChange={() =>
													// 	setValue("mailingToGroups", true, {
													// 		shouldValidate: true,
													// 	})
													// }
													margin="none"
													name="mailingGroups_1"
													label="Grupa 1 - wybierz"
													defaultValue=""
													options={mailingGroupOptions}
												/>
											)}
										</Box>
									</Grid>
									<Grid size={4}>
										<Box sx={{ alignItems: "center", display: "flex" }}>
											{isLoadingGroups ? (
												<Skeleton
													variant="rectangular"
													width={155.77}
													height={36.72}
												/>
											) : (
												<ControlledSelect
													control={control}
													allowRefresh={true}
													// resetField={resetField}
													// onChange={() =>
													// 	setValue("mailingToGroups", true, {
													// 		shouldValidate: true,
													// 	})
													// }
													margin="none"
													name="mailingGroups_2"
													label="Grupa 2 - wybierz"
													defaultValue=""
													options={mailingGroupOptions}
												/>
											)}
										</Box>
									</Grid>
									<Grid size={4}>
										<Box sx={{ alignItems: "center", display: "flex" }}>
											{isLoadingGroups ? (
												<Skeleton
													variant="rectangular"
													width={155.77}
													height={36.72}
												/>
											) : (
												<ControlledSelect
													control={control}
													allowRefresh={true}
													// resetField={resetField}
													// onChange={() =>
													// 	setValue("mailingToGroups", true, {
													// 		shouldValidate: true,
													// 	})
													// }
													margin="none"
													name="mailingGroups_3"
													label="Grupa 3 - wybierz"
													defaultValue=""
													options={mailingGroupOptions}
												/>
											)}
										</Box>
									</Grid>
								</Grid>
							</Box>
						</Grid>
						<Grid size={12}>
							<Box sx={{ p: "0 16px 10px" }}>
								<ControlledCheckbox
									control={control}
									margin="normal"
									name="smsToSelectedContacts"
									label={
										<span>
											Wyślij SMS do zapisanych kontaktów{" "}
											<em>(przewoźnik ma opcję kwotowania)</em>
										</span>
									}
								/>
							</Box>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={4.5} sx={{ borderLeft: "1px solid #bfbfbf" }}>
					<Box sx={{ p: "6px 10px" }}>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "start",
							}}
						>
							<Button
								variant="contained"
								size="small"
								sx={{ p: 0, boxShadow: "none" }}
								onClick={handleSelectAllContacts}
							>
								Wszyscy
							</Button>
							<Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
								<span>Grupa kontaktów:</span>
								<FormControl sx={{ width: 120 }} size="small">
									{isLoadingGroups ? (
										<Skeleton
											variant="rectangular"
											width={120}
											height={23.72}
										/>
									) : (
										<Select
											slotProps={{
												input: {
													sx: { p: "2px 10px" },
												},
											}}
											value={selectedGroup}
											size="small"
											onChange={(e) => setSelectedGroup(e.target.value)}
										>
											{mailingGroupOptions.map((option) => (
												<MenuItem
													key={option.value}
													value={option.value}
													disabled={option.disabled || false}
												>
													{option.label}
												</MenuItem>
											))}
										</Select>
									)}
								</FormControl>
							</Box>
						</Box>
						<Box
							sx={{
								maxHeight: "420px",
								overflow: "scroll",
								marginTop: "10px",
							}}
						>
							<MultiSelectableList
								data={filteredRecipients}
								selectedItems={selectedContacts}
								setSelectedItems={setSelectedContacts}
								isLoading={isLoading || isFetching}
							/>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Dialog>
	);
};

const MultiSelectableList = ({
	data,
	selectedItems,
	setSelectedItems,
	isLoading,
}) => {
	const handleToggle = (contact) => {
		const exists = selectedItems.some(
			(c) => c.phone === contact.phone // or contact.id if you have one
		);

		if (exists) {
			setSelectedItems((prev) => prev.filter((c) => c.phone !== contact.phone));
		} else {
			setSelectedItems((prev) => [...prev, contact]);
		}
	};

	if (isLoading) {
		return "Ładowanie...";
	}

	return (
		<List sx={{ p: 0 }}>
			{data.length > 0 ? (
				<>
					{data.map((item, index) => {
						const isSelected = selectedItems.some(
							(c) => c.phone === item.phone
						);

						return (
							<ListItem
								key={index}
								button
								onClick={() => handleToggle(item)}
								sx={{
									backgroundColor: isSelected
										? "#d9f2d0"
										: index % 2 === 0
										? "white"
										: "#f9f9f9",
									"&:hover": {
										backgroundColor: "#e6ffe6",
									},
									p: "4px 12px",
									cursor: "pointer",
								}}
							>
								<Box
									sx={{
										width: "100%",
										display: "flex",
										justifyContent: "space-between",
										fontSize: "12px",
									}}
								>
									<span>{item.name}</span>
									<span>{item.phone}</span>
								</Box>
							</ListItem>
						);
					})}
				</>
			) : (
				<Typography sx={{ textAlign: "center" }}>
					Brak kontaków z numerem telefonu w grupie
				</Typography>
			)}
		</List>
	);
};
